import platformHelpers from 'Models/uiConfig/platformHelpers';
import storageHelpers, { localStorage } from 'Utils/browserStorage';
import stringHelpers from 'Utils/string';

platformHelpers.initializePlatformHelpers();

window.Convermax.helpers = {
  ...(window.Convermax.helpers || {}),
  ...stringHelpers,
  ...storageHelpers,
};

window.Convermax.localStorage = localStorage;
